import storage from 'proxy-storage'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'

import addEventListener from 'utils/DOM/addEventListener'
import removeEventListenerBySelector from 'core/DOM/removeEventListenerBySelector'
import buildControllerGender from 'core/controllers/buildControllerGender'
import getMemberIdBySuffix from 'utils/pivot/member/getMemberIdBySuffix'
import buildControllerDOB from 'core/controllers/buildControllerDOB'
import querySelectorAll from 'utils/DOM/querySelectorAll'
import setValueToSelect from 'utils/DOM/setValueToSelect'
import removeElements from 'utils/DOM/removeElements'
import { DIGITS_REGEX } from 'core/constants/regex'
import toggleClass from 'utils/DOM/toggleClass'
import changeEvent from 'core/DOM/changeEvent'
import { stringToAge } from '@hc-frontend/utils'
import getById from 'utils/DOM/getById'
import { findApplicant, findChildren, findSpouse } from '@hc-frontend/business'
import { MemberType } from '@hc-frontend/entities'

let spouseWrap = null
let childrenWrap = null
let template = null
let addSpouseButtons = null
let addSpouseButtonsArr = null
let addSpouseButtonNo = null
let addSpouseButtonYes = null
let addChildButton = null
let addChildButtonArr = null
let addChildButtonNo = null
let addChildButtonYes = null
let childNumberSelect = null
let addSpouseWrap = null
const controllers = {}
const SUFFIX_TO_SPOUSE = 's'
const MAX_CHILDREN = 10
let totalChild = 0
let suffixChild = 0
let thereIsSpouse = false
let getSdate

function init() {
  spouseWrap = getById('spouse-wrap')
  childrenWrap = getById('children-wrap')
  template = Templater(getById('template-member').innerText)
  addSpouseButtons = document.getElementsByName('add-spouse')
  addSpouseButtonsArr = Array.from(addSpouseButtons)
  addSpouseButtonNo = addSpouseButtonsArr.find(btn => btn.value === 'no')
  addSpouseButtonYes = addSpouseButtonsArr.find(btn => btn.value === 'yes')
  addChildButton = document.getElementsByName('add-child')
  addChildButtonArr = Array.from(addChildButton)
  addChildButtonNo = addChildButtonArr.find(btn => btn.value === 'no')
  addChildButtonYes = addChildButtonArr.find(btn => btn.value === 'yes')
  childNumberSelect = getById('child-number')
  addSpouseWrap = getById('wrap-add-spouse')

  addEventListener('[name="add-spouse"]', 'change', () => {
    if (!thereIsSpouse) {
      addSpouse()
    } else {
      removeMemberById('s')
    }
  })
  addEventListener('[name="add-child"]', 'change', () => {
    if (addChildButtonNo.checked) {
      const removeChildButtons = Array.from(
        querySelectorAll('#children-wrap .c-Form__close')
      )
      removeChildButtons.forEach(elem => {
        removeMemberById(elem.dataset.id)
      })
      toggleClass(document.body, 'add-children', false)
    } else {
      toggleClass(document.body, 'add-children', true)
    }
  })
  addEventListener(childNumberSelect, 'change', e => {
    if (!addChildButtonNo.checked) {
      const node = e.target
      const number = DIGITS_REGEX.test(node.value) ? parseInt(node.value, 10) : 0
      const diff = number - totalChild

      if (diff > 0) {
        for (let idx = 0; idx < diff; idx++) {
          addChild()
        }
      } else if (diff < 0) {
        const removeChildButtons = Array.from(
          querySelectorAll('#children-wrap .c-Form__close')
        )
        removeChildButtons
          .slice(diff)
          .reverse()
          .forEach(elem => {
            window.setTimeout(() => {
              removeMemberById(elem.dataset.id)
            }, 0)
          })
      }
    }
  })
}

function removeMemberById(id) {
  const hcStorage = storage.getItem('hc')
  const suffix = id && id.indexOf('_') > -1 ? id.split('_').pop() : id
  const dobId = `dob_${suffix}`
  const genderId = `gender_${suffix}`
  const ids = getMemberIdBySuffix(suffix)
  const membersLeft = hcStorage.members.filter(person => person.id !== ids.id)
  const applicant = findApplicant(membersLeft)
  const spouse = findSpouse(membersLeft)
  const childrenLeft = findChildren(membersLeft)

  hcStorage.members = [applicant, spouse, ...childrenLeft].filter(Boolean)

  removeEventListenerBySelector(`#${id} .c-Form__close`, 'click', removeMember)
  removeElements(`#${id}`)
  controllers[dobId].destroy()
  controllers[genderId].destroy()
  delete controllers[dobId]
  delete controllers[genderId]

  if (suffix === SUFFIX_TO_SPOUSE) {
    thereIsSpouse = false
    addSpouseButtonNo.checked = true
  } else {
    totalChild -= 1
    setValueToSelect(childNumberSelect, totalChild.toString())
    if (totalChild === 0) {
      addChildButtonNo.checked = true
      toggleClass(document.body, 'add-children', false)
    }
  }

  storage.setItem('hc', hcStorage)
}

function removeMember(e) {
  return removeMemberById(e.target.getAttribute('data-id'))
}

function createMember(config, member = {}) {
  const htmlObject = document.createElement('div')
  htmlObject.id = config.id
  htmlObject.innerHTML = template(config)

  if (config.type === MemberType.Spouse) {
    spouseWrap.appendChild(htmlObject)
  } else {
    childrenWrap.appendChild(htmlObject)
  }

  const dobId = `dob${config.suffix}`
  controllers[dobId] = buildControllerDOB({
    input: getById(dobId),
    typeMember: config.type,
    getSdate: () => getSdate()
  })
  controllers[dobId].setValue(member.stringDOB)

  const genderId = `gender${config.suffix}`
  controllers[genderId] = buildControllerGender({
    inputs: document.forms.form[genderId]
  })
  controllers[genderId].setValue(member.gender)

  addEventListener(`#${config.id} .c-Form__close`, 'click', removeMember)
}

function addSpouse(member) {
  const suffix = SUFFIX_TO_SPOUSE
  thereIsSpouse = true

  createMember(
    {
      id: suffix,
      title: 'Your Spouse',
      suffix: `_${suffix}`,
      type: MemberType.Spouse
    },
    member
  )
}

function addChild(member) {
  if (totalChild < MAX_CHILDREN) {
    totalChild += 1
    suffixChild += 1

    createMember(
      {
        id: `c_${suffixChild}`,
        title: 'Child',
        suffix: `_${suffixChild}`,
        type: MemberType.Child
      },
      member
    )
  }
}

function loadMembers(members) {
  let noChildFound = true
  for (let index = 0; index < members.length; index++) {
    const member = members[index]

    if (member.type === MemberType.Spouse) {
      addSpouseButtonYes.checked = true
      addSpouse(member)
    } else if (member.type === MemberType.Child) {
      if (noChildFound) {
        addChildButtonYes.checked = true
        addChildButtonYes.dispatchEvent(changeEvent)
      }
      addChild(member)
      setValueToSelect(childNumberSelect, totalChild.toString())
      noChildFound = false
    }
  }
}

function getControllers() {
  let countChild = 0
  const suffixes = {}
  const result = {}

  for (const key in controllers) {
    const [inputName, suffix] = key.split('_')
    if (suffix === SUFFIX_TO_SPOUSE) {
      result[key] = controllers[key]
    } else {
      suffixes[suffix] = suffixes[suffix] || ++countChild
      result[`${inputName}_${suffixes[suffix]}`] = controllers[key]
    }
  }

  return result
}

function isUnder18YearsOfAge(date) {
  return !!date && stringToAge(date) < 18
}

function applicantDateUpdated(date) {
  const under18YearsOfAge = isUnder18YearsOfAge(date)

  if (under18YearsOfAge) {
    if (thereIsSpouse) {
      removeMemberById('s')
    }
    addSpouseWrap.disabled = true
  } else if (!thereIsSpouse) {
    addSpouseWrap.disabled = false
  }
  toggleClass(document.body, 'child-only', under18YearsOfAge)
}

export default {
  setGetSdate: fn => {
    getSdate = fn
  },
  init,
  loadMembers,
  getControllers,
  applicantDateUpdated,
  childOnly: isUnder18YearsOfAge
}
